import React from 'react';
import PropTypes from 'prop-types';

const CheckBox = (props) => {
  const { name, id, size, children, checked, onChange, disabled, bold } = props;
  const inputId = name + id;

  return (
    <div className={`checkBox ${bold ? 'bold' : ''}`}>
      <input
        id={inputId}
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <label htmlFor={inputId} className={`${size} ${children ? 'labelText' : ''}`}>
        {children}
      </label>
    </div>
  );

};

CheckBox.defaultProps = {
  name: 'check-group',
  id: 'check-box',
  size: 'md',
  bold: false,
};

CheckBox.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  children: PropTypes.node,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  bold: PropTypes.bool,
};

export default CheckBox;
